import { useQuery } from 'react-query';

import { expensesApi } from 'src/Services/API';

interface UseFetchBalanceDetailsParams {
  assetId: string;
  userId?: string;
  bankAccountId?: string;
  contactId?: string;
  enabled?: boolean;
}

const useFetchBalanceDetails = ({
  assetId,
  userId,
  bankAccountId,
  contactId,
  enabled = true,
}: UseFetchBalanceDetailsParams) => {
  const isEnabled = !!assetId && enabled && (!!userId || !!bankAccountId || !!contactId);

  return useQuery({
    queryKey: ['fetch-balance-details', assetId, userId, bankAccountId, contactId],
    queryFn: async () => {
      if (!assetId) throw new Error('No assetId provided');

      return (
        await expensesApi.expensesControllerGetBalanceDetail(
          assetId,
          userId,
          bankAccountId,
          contactId
        )
      ).data;
    },
    enabled: isEnabled,
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
  });
};

export default useFetchBalanceDetails;
